import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import {useSocket} from '../../../../core/contexts/SocketContext';
import { useEffect, useState } from 'react';
import sleep from 'sleep-promise';
function List() {
    const profileFilter = chooseProfileFilter();
    const { setMessageListener, clearMessageListener } = useSocket();
    const [listContainer, setListContainer] = useState(); 
    
    useEffect(() => {
        const handleSocketMessage = async (data) => {
          const list = getList();
          setListContainer(<></>);
          await sleep(1);
          setListContainer(
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        )
        };
    
        setMessageListener(handleSocketMessage);
    
        return () => {
          clearMessageListener();
        };
      }, []);

    const pathFrontEnd = '/accountingprojects/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}accountingprojects/delete`,
        endpoint: config.endpoints.backend + 'accountingprojects/getall'
    }

    const getList = () => {
        const filters = {
            validateOnChange: true,
            showGoBackButton: false,
            showSubmitButton: false,
            handleSubmit: loadData,
            fields: [
                {
                    name: 'project_name',
                    type: 'text',
                    label: 'Nome do Projeto',
                    validations: {
                        required: false
                    },
                    columnSize: 3,
                },
                {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 3,
                },
                {
                    name: 'filtro',
                    type: 'submit',
                    label: 'Pesquisar',
                    columnSize: 1
                },
                {
                    name: 'reset',
                    type: 'reset',
                    label: 'Limpar',
                    columnSize: 2
                },
            ]
        }

        let list = {
            labelTitle: 'Lista de Projetos Contabeis',
            labelTitleButtonAdd: 'Incluir novo projeto',
            fieldsShowOnDelete: ['despro'],
            showPrintButtons: true,
            formFilters: !profileFilter.pdc_entity_id ? filters : null,
            canAdd: false,
            canDelete: false,
            filter: {
                ...profileFilter
            },
            columns: [
                {
                    name: 'entity',
                    label: 'Entidade'
                },
                {
                    name: 'project_name',
                    label: 'Nome do Projeto'
                },
                {
                    name: 'status_file_name',
                    label: 'Status'
                }
            ]
        };

        return { ...list, ...paths };
    }

    useEffect(() => {
        const load = async () => {
            const list = getList();
            setListContainer(
                <CustomListContainer
                    canAdd={list.canAdd}
                    pathAdd={list.pathAdd}
                    labelTitle={list.labelTitle}
                    labelTitleButtonAdd={list.labelTitleButtonAdd}
                    content={<CustomList list={list} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {listContainer}
        </div>
    );
}
export default List;
